import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS } from "../../../config/api";
import { useNavigate } from "react-router-dom";
import Pagination from "../../../components/private/pagination";

const PlanAccion = () => {
  const { authFetch } = useContext(AuthContext);
  const navigate = useNavigate();

  const [planes, setPlanes] = useState([]);
  const [programas, setProgramas] = useState([]);
  const [loading, setLoading] = useState(true);

  const [programFilter, setProgramFilter] = useState("");
  const [stateFilter, setStateFilter] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const recordsPerPage = 10;

  // =========================
  // CARGAR PLANES
  // =========================
  const loadPlanes = useCallback(async () => {
    setLoading(true);

    const res = await authFetch(ENDPOINTS.get_plan);

    if (res.success) {
      setPlanes(res.data || []);
    } else {
      setPlanes([]);
    }

    setLoading(false);
  }, [authFetch]);

  useEffect(() => {
    loadPlanes();
  }, [loadPlanes]);

  // =========================
  // CARGAR PROGRAMAS
  // =========================
  useEffect(() => {
    const loadProgramas = async () => {
      const res = await authFetch(ENDPOINTS.get_programas);
      if (res.success) {
        setProgramas(res.data || []);
      }
    };

    loadProgramas();
  }, [authFetch]);

  // =========================
  // FILTRO
  // =========================
  const filteredPlanes = planes.filter((plan) => {
    const matchesProgram =
      programFilter === "" || plan.programa_nombre === programFilter;

    const matchesState =
      stateFilter === "" || plan.status.toString() === stateFilter;

    return matchesProgram && matchesState;
  });

  const totalPages = Math.ceil(filteredPlanes.length / recordsPerPage);

  const currentPlanes = filteredPlanes.slice(
    (currentPage - 1) * recordsPerPage,
    currentPage * recordsPerPage
  );

  const goToPage = (page) => {
    if (page >= 1 && page <= totalPages) setCurrentPage(page);
  };

  if (loading) return <p>Cargando planes...</p>;

  return (
    <div className="container mt-4 p-4">

      {/* HEADER */}
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2>Planes de Acción</h2>

        <button
          className="btn btn-outline-pink"
          onClick={() => navigate("/session/plan_accion/createPlan")}
        >
          <i className="bi bi-plus-lg me-1"></i>Planes
        </button>
      </div>

      {/* FILTROS */}
      <div className="row mb-3">

        {/* FILTRO PROGRAMA */}
        <div className="col-md-6">
          <label className="m-1">Filtrar por programa</label>
          <select
            className="form-select"
            value={programFilter}
            onChange={(e) => {
              setProgramFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">Todos</option>
            {programas.map((prog) => (
              <option key={prog.id} value={prog.program_name}>
                {prog.program_name}
              </option>
            ))}
          </select>
        </div>

        {/* FILTRO ESTADO */}
        <div className="col-md-6">
          <label className="m-1">Filtrar por estado</label>
          <select
            className="form-select"
            value={stateFilter}
            onChange={(e) => {
              setStateFilter(e.target.value);
              setCurrentPage(1);
            }}
          >
            <option value="">Todos</option>
            <option value="0">Activos</option>
            <option value="1">Inactivos</option>
          </select>
        </div>
      </div>

      {/* TABLA */}
      {currentPlanes.length > 0 ? (
        <>
          <table className="table table-hover">
            <thead className="table-secondary">
              <tr>
                <th>Área</th>
                <th>Programa</th>
                <th>Nombre</th>
                <th>Fecha Inicio</th>
                <th>Fecha Fin</th>
                <th>Duración</th>
                <th>Estado</th>
                <th>Acciones</th>
              </tr>
            </thead>

            <tbody>
              {currentPlanes.map((plan) => (
                <tr key={plan.id}>
                  <td>{plan.area_nombre}</td>
                  <td>{plan.programa_nombre}</td>
                  <td>{plan.name}</td>
                  <td>{plan.date_start}</td>
                  <td>{plan.date_end}</td>
                  <td>{plan.duracion_meses} meses</td>

                  <td>
                    {plan.status === 0 ? (
                      <span className="badge bg-success">Activo</span>
                    ) : (
                      <span className="badge bg-secondary">Inactivo</span>
                    )}
                  </td>

                  <td>
                    <button
                      className="btn btn-sm bg-success text-white"
                      onClick={() => {
                        const url = `${ENDPOINTS.report_plan_accion}?id_plan=${plan.id}`;
                        window.open(url, "_blank");
                      }}
                    >
                      Excel
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>

          {/* PAGINACIÓN */}
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
          />
        </>
      ) : (
        <p>No hay planes registrados.</p>
      )}
    </div>
  );
};

export default PlanAccion;
